import { useState } from 'react';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performPutRequest } from '@atlassian/jira-fetch';

const REST_API_PATH_AFTER = '/rest/board-api/1/rank/rankAfter';
const REST_API_PATH_BEFORE = '/rest/board-api/1/rank/rankBefore';

export const useRankIssue = () => {
	const [loading, setLoading] = useState(false);

	const rankIssueBefore = ({
		issueId,
		relativeIssueId,
		onError,
	}: {
		issueId: number;
		relativeIssueId: number | null;
		onError?: (arg1: Error) => void;
	}) => {
		setLoading(true);

		return performPutRequest(`${REST_API_PATH_BEFORE}`, {
			body: JSON.stringify({
				issueId,
				relativeIssueId,
			}),
		})
			.then(() => {
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				onError && onError(error);
				fireErrorAnalytics({
					meta: {
						id: 'jwmBoardRank',
						packageName: 'jiraWorkManagementBoard',
						teamName: 'wanjel',
					},
					attributes: {
						message: 'Failed to rank issue before in JWM board',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
				throw error;
			});
	};

	const rankIssueAfter = ({
		issueId,
		relativeIssueId,
		onError,
	}: {
		issueId: number;
		relativeIssueId: number | null;
		onError?: (arg1: Error) => void;
	}) => {
		setLoading(true);

		return performPutRequest(`${REST_API_PATH_AFTER}`, {
			body: JSON.stringify({
				issueId,
				relativeIssueId,
			}),
		})
			.then(() => {
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				onError && onError(error);
				fireErrorAnalytics({
					meta: {
						id: 'jwmBoardRank',
						packageName: 'jiraWorkManagementBoard',
						teamName: 'wanjel',
					},
					attributes: {
						message: 'Failed to rank issue after in JWM board',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
				throw error;
			});
	};

	return { loading, rankIssueBefore, rankIssueAfter };
};
